export default __webpack_public_path__ + "static/media/a6_postcard_portrait.5f3d0d86.png";